import { Button, Grid, Typography } from "@mui/material";
import { timeAgo } from "../utilities";

function Notify(props) {
  return (
    <>
      <div className="NotifyTopGrid">
        <Grid item className="NotifyImg">
          <div className="NotifyImg1"></div>
        </Grid>
        <div className="NotifyText">
          <Grid item className="NotifyMainText">
            <Typography className="flex" fontSize={14}>
              <span className="font-bold">
                {props.name}
              </span>
              {props.text}
            </Typography>
          </Grid>
          {props?.date ? 
          <span className="NotifySubText">
            {/* {props.time} ago */}
            {timeAgo(props?.date)}
          </span> : null}
          {props.view === true ? (
            <>
              <Grid item container>
                <Button variant="outlined" className="view-decline-btn">
                  View
                </Button>
              </Grid>
            </>
          ) : null}
          {props.ad === true ? (
            <>
              <Grid item container>
                <Button variant="contained" className="accept-btn">
                  Accept
                </Button>

                <Button variant="outlined" className="view-decline-btn">
                  Decline
                </Button>
              </Grid>
            </>
          ) : null}

        </div>
      </div>
      
      {/* <div className="border-b w-full" /> */}
    </>
  );
}

export default Notify;
